import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { OrdersPageRoute } from '@/routes/orders/OrdersPage.route'

export const OrderBillingRoute: TileRoleRoute = {
  path: 'orderbilling',
  text: 'Fatturazione Ordine',
  faIcon: faFileInvoice,
  element: (
    <ManagementGridFactory
      entity={'stato_fatturazione_ordine'}
      referencesCollection={'ordini'}
      referencesTitle={'Fatturazione Ordine'}
      displayField={'ded_Dis'}
      entityRoute={OrdersPageRoute.path as string}
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Fatturazione Ordine',
      icon: faFileInvoice,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
